import React, { useState, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { projectsApi } from "../../../utils";
import { throwApiError } from "../../lms-shared/store/error-handling-actions";
import Project from "./Project";

const ProjectContainer = () => {

    const { texts } = useSelector(state => state.translate);
    const [projectData, setProjectData] = useState({})
    const { studyGroupId, projectId } = useParams()
    const dispatch = useDispatch()

    useEffect(() => {
        // if (lang) {
        let data = {
            id: projectId,
            studyGroupId: studyGroupId
        }
        projectsApi.projectsFilterPost({ projectFilter: data }, (error, resProjectData, response) => {
            if (error) {
                dispatch(throwApiError({ userMessage: texts.projectsFilterIdError, error: error, statusCode: response?.statusCode, message: "projectsFilterIdPost " + error.message, level: 2, component: "ProjectContainer", line: 19 }))
                if (error.status == 403) {
                    dispatch(throwApiError({ userMessage: texts.MessageContentProjectsFilterIdNoPermissions, error: error, statusCode: response?.statusCode, message: "projectsFilterIdPost " + error.message, level: 2, component: "Project", line: 62 }))
                } else {
                    dispatch(throwApiError({ userMessage: texts.MessageContentProjectsFilterId, error: error, statusCode: response?.statusCode, message: "projectsFilterIdPost " + error.message, level: 2, component: "Project", line: 65 }))
                }
            } else {
                if (resProjectData) {
                    setProjectData({
                        assessmentName: resProjectData.name,
                        ideUrl: resProjectData.ide.url,
                        ideConfig: JSON.parse(resProjectData.ide.additionalConfiguration),
                        lessonId: resProjectData.submission?.lessonId,
                        studyGroupId: resProjectData.submission?.studyGroupId
                    })
                }
            }
        })
        // }
        // }, [lang])
    }, [])

    return (
        <Project attachmentUrl={projectData.attachmentUrl} ideUrl={projectData.ideUrl} ideConfig={projectData.ideConfig} ></Project >
    )
};

export default ProjectContainer;
